import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem, CircularProgress, Autocomplete, TextField } from '@mui/material';
import { API } from '../helpers/API';
import { getEstados, getEstadoById } from '../helpers/Location';

const estados = getEstados();

function FieldUfCidade({ value, onChange, id, inputStyle, errors, onBlur, validate }) {

    const [uf, setUf] = useState(value?.uf || '');
    const [cidade, setCidade] = useState(value?.cidade || null);
    const [cidades, setCidades] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if( uf ){
            fetchCidades( uf );
        }
    }, [ uf ]);

    useEffect(() => {
        setUf( value?.uf || '' );
    }, [ value.uf ]);

    useEffect(() => {
        setCidade(value?.cidade || null);
    }, [ value.cidade ]);

    async function fetchCidades(sigla) {

        setLoading(true);
        setCidades([]);
        setCidade(null);

        const UF = isNaN(sigla) ? sigla.toUpperCase() : getEstadoById(sigla);
        const lista = await API.getCidades(UF);
        if (lista) {
            setCidades(lista.map(c => ({ id: c.id, text: c.text })));
        }

        setLoading(false);

    }

    function handleUF( val ){

        const newUf = val || '';

        setUf( newUf );
        setCidade( null );

        onChange({ name: 'uf', value: newUf });
        onChange({ name: 'cidade', value: '' });

    }

    function handleCidade(val) {
        setCidade( val );
        onChange({ name: 'cidade', value: val ? val.id : '' });
    }

    // cidades
    const bindBlur = ( field ) => {
        if( onBlur ){
            onBlur( field, ( field === 'uf' ? uf : cidade ) )
        }
    }

    const optionLabel = (option) => (typeof option === 'string' ? option : (option?.nome ? option.nome : option.text))
    const isActive = (option, value) => (option.text === value.text)

    // Show city
    let cidadeShow = '';
    if( cidade && cidade !== '' ){
        const cityfind = cidades.find( itemcity => itemcity.id.toString() === cidade.toString() )
        if( cityfind ){
            cidadeShow = cityfind.text
        }
    }

    return (
        <div className="ufcidade" style={{ display: 'flex' }}>

            <div className={errors.uf ? "error" : ""}>
                <Autocomplete
                    options={estados}
                    getOptionLabel={optionLabel}
                    isOptionEqualToValue={isActive}
                    value={estados.find(e => e.text === uf) || null}
                    onChange={(e, val) => handleUF(val ? val.text : '')}
                    onBlur={() => { bindBlur( 'uf' ) }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Estado*"
                            variant="outlined"
                            style={{ minWidth: 240 }}
                            sx={inputStyle}
                            error={errors.uf}
                        />
                    )}
                    slotProps={{
                        paper: {
                            sx: {
                                '& .MuiAutocomplete-option': { fontSize: '14px' }
                            }
                        }
                    }}
                />
                <em className={errors.uf ? "error " : ""}>{`${errors.uf} `}</em>
            </div>

            <div className={errors.cidade ? "error" : ""} style={{ width: '100%' }}>
                <Autocomplete
                    fullWidth
                    options={cidades}
                    getOptionLabel={optionLabel}
                    getOptionKey={(option) => option.id}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    value={cidadeShow || null}
                    onChange={(e, val) => handleCidade(val || null)}
                    onBlur={() => { bindBlur( 'cidade' ) }}
                    loading={loading}
                    disabled={(!cidades.length && !loading)}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Município*"
                            variant="outlined"
                            sx={inputStyle}
                            error={errors.cidade}
                        />
                    )}
                    slotProps={{
                        paper: {
                            sx: {
                                '& .MuiAutocomplete-option': { fontSize: '14px' }
                            }
                        }
                    }}
                />
                <em className={errors.cidade ? 'error' : ''}>{`${errors.cidade ? errors.cidade : ' '} `}</em>
            </div>

        </div>
    );

}

export default FieldUfCidade;